import Place from '@/models/place.model';

/**
 * Requests the permission
 * to access the geolocation
 * API and returns a promise
 * fulfilling with the place
 * or null
 */
export default async function getCurrentPosition(): Promise<Place | null> {
    if (!navigator.geolocation) {
        return null;
    }

    return new Promise<Place | null>((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(position => {
            resolve({
                lat: position.coords.latitude,
                lng: position.coords.longitude,
            });
        }, () => {
            reject();
        });
    });
}
